import Model from '@/lib/data/Model';

class VisitQraGraph extends Model {
    fields = [{ name: 'qra_graph_json', type: 'json' }, { name: 'qra_questions' }];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/visit/riskimprovement/getscore',
            params: ['visit_id'],
        },
    ];
}

export default VisitQraGraph;
